var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCollapseAll = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-icon",
  style: {
    width: "1em",
    height: "1em",
    verticalAlign: "middle",
    fill: "currentColor",
    overflow: "hidden"
  },
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M718.933333 786.773333a20.48 20.48 0 0 1 0 29.866667l-30.293333 30.293333a21.333333 21.333333 0 0 1-29.866667 0L512 699.733333l-146.773333 147.2a21.333333 21.333333 0 0 1-30.293334 0l-29.866666-30.293333a20.48 20.48 0 0 1 0-29.866667l176.213333-177.066666a32 32 0 0 1 22.613333-9.386667h16.213334a32.853333 32.853333 0 0 1 22.613333 9.386667z m-237.653333-369.493333a32.853333 32.853333 0 0 0 22.613333 9.386667h16.213334a32 32 0 0 0 22.613333-9.386667l176.213333-176.64a21.333333 21.333333 0 0 0 0-30.293333l-29.866666-30.293334a21.333333 21.333333 0 0 0-30.293334 0L512 327.253333 365.226667 180.48a20.906667 20.906667 0 0 0-29.866667 0l-30.293333 30.293333a21.333333 21.333333 0 0 0 0 30.293334z"
})));
export default SvgCollapseAll;